baseApp.service('LocationService', function(){
    var locationFactory ={
        popLocations : {},
        publishedIpIdPrefix : 'PUBLISHED_',
        allocatedIpIdPrefix : 'ALLOCATED_IPS_',
    };
    var searchLocation = {};
    var countries;
    var maxAccountCache = 5;

    /**
     * get countries and preforming callback
     * @param callback
     */
    locationFactory.getCountries = function(callback){
        if(!countries){
            store.fetch({
                path: "/countries",
                success: function(data) {
                    countries = data;
                    if(callback){
                        callback(countries);
                    }
                }
            });
        }
        else{
            if(callback){
                callback(countries);
            }
        }
    };

    /**
     * return the location by the location id
     * @param locationId
     * @returns {string}
     */
    locationFactory.getPopLocationViaLocationId = function(accountId, locationId) {
        if(locationFactory.popLocations[accountId] && locationFactory.popLocations[accountId].popLocations) {
            var popLocations = locationFactory.popLocations[accountId].popLocations;
            var foundLocation = null;
            popLocations.forEach(function (location) {
                if (locationId == location.id){
                    foundLocation = location;
                }
            });
            return foundLocation;
        }
        return null;
    };

    locationFactory.getAllocatedIpsWithLocations = function(accountId, callback, rpf= false) {
        store.fetch({
        	path: `/getAllocatedIps?accountId=${accountId}&fetchNatIps=true&forRpf=${rpf}`,
        	success: function(data) {
        		if (data && data.items) {
        			data.items.forEach(function (item) {
        				if (item.type === 'ALLOCATED_IPS') {
        					var location = locationFactory.getPopLocationViaLocationId(accountId, item.locationId);
        					if (location && location.name){
        						item.location = location.name;
        						item.displayName = item.location;
        					} else {
        						item.displayName = 'Allocated IP'
        					}
        				} else {
        					item.displayName = 'Published IP';
        				}
        				item.displayName +=  ' - ' + item.ip;
        			});
        			callback(data.items);
        		} else {
        			callback([]);
        		}
        	}
        });
    }

    locationFactory.hasLocationForAccount = function(accountId) {
        return locationFactory.popLocations[accountId] && locationFactory.popLocations[accountId].popLocations;
    };

    /**
     * method for loading pop locations for accountId and preforming callback - if pop location already in cache only run callback
     **/
    locationFactory.getPopLocations = function(accountId, callback) {
        if (locationFactory.popLocations[accountId]){
            //update access timestamp - to make sure record is more "fresh" in the cache
            locationFactory.popLocations[accountId].timestamp = new Date().getTime();
            if (callback && locationFactory.popLocations[accountId] && locationFactory.popLocations[accountId].popLocations){
                callback(angular.copy(locationFactory.popLocations[accountId].popLocations));
            }
        }
        else {
            loadPopLocations(accountId, callback);
        }
    };

    // used only by system, not caching at the moment
    locationFactory.getPopMachines = function(accountId, callback) {
        loadPopMachines(accountId, callback);
    };

    function loadPopMachines(accountId, callback){
        store.fetch({
            path: "getMachinesById",
            success: function(data) {
                if (callback){
                    callback(angular.copy(data));
                }
            }
        });
    };

    function loadPopLocations(accountId, callback){
        store.fetch({
            path: "getlocations?accountId=" + accountId,
            success: function(data) {
                clearOldestFromCache();
                data.unshift({"id":0,"name":""});
                locationFactory.popLocations[accountId] = {"popLocations" : data, "timestamp" : new Date().getTime()};
                if (callback){
                    callback(angular.copy(data));
                }
            }
        });
    };

    function clearOldestFromCache(){
        if(Object.keys(locationFactory.popLocations).length == maxAccountCache){
            var oldestAccount;
            var oldestTimestamp = Number.MAX_VALUE;
            for(let accountId in locationFactory.popLocations){
                var popLocations = locationFactory.popLocations[accountId];
                if(popLocations.timestamp  < oldestTimestamp){
                    oldestTimestamp = popLocations.timestamp;
                    oldestAccount = accountId;
                }
            }
            delete  locationFactory.popLocations[oldestAccount];
        }
    };

    return locationFactory;
});
